import * as React from 'react';

interface Props{
  time:number,
  onfinish:any
}

export const Timer: React.FC<Props> = ({
  time, onfinish 
}): JSX.Element=> {
  const [timer, setTimer] = React.useState(1);
  const id:any = React.useRef(null);
  const clear = () => {
    window.clearInterval(id.current);
  };
  React.useEffect(() => {
    id.current = window.setInterval(() => {
      setTimer((value:number) => value - 1);
    }, 1000);
    if (timer === 0) {
      clear();
      onfinish();
    }
    return () => clear();
  }, [timer]);

  React.useEffect(() => {
    setTimer(time);
  }, [time]);

  const secondsToHms=(d:number)=> {
    d = Number(d); 
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);

    const mDisplay =
      m > 0 && m < 10 ? `${m} ` + (m === 1 ? " : " : " : ") : "0 : ";
      const sDisplay = s >= 0 && s < 10 ? `0${s}` : s;

    return mDisplay + sDisplay;
  }

  return (
    <span className="Timer" key={time}>
      <b>{secondsToHms(timer)}</b>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/pages/auth/Login/Timer.tsx